import { render, staticRenderFns } from "./NewPackagingDialog.vue?vue&type=template&id=d507e052&scoped=true"
import script from "./NewPackagingDialog.vue?vue&type=script&lang=js"
export * from "./NewPackagingDialog.vue?vue&type=script&lang=js"
import style0 from "./NewPackagingDialog.vue?vue&type=style&index=0&id=d507e052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d507e052",
  null
  
)

export default component.exports